import { useSelector } from "react-redux"
import { createCustomerRequest } from "../../services/customerService";

export function DebugToolCustomerSnippet() {
    const user: User = useSelector((state: AppState) => state.currentUser)
    
    function onShow() {
        const req = createCustomerRequest(user);
        return JSON.stringify(req, null, 1);
    }
    return (
        <div className="snippet-container">
            <pre>
                { onShow() }
            </pre>
        </div>
    )
}